import { Component } from '@angular/core';

@Component({
    selector: 'article',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class ArticleComponent {}
